import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Privacy.css';

const Terms = () => {
  return (
    <>
      <div className="home-container">
        <Navbar />
        <div className="terms-hero">
          <h1 className="terms-home-title">Terms of Use</h1>
          <p className='hero-date'>Last Updated: <span style={{color: '#3EC182'}}>14TH February, 2025</span></p>
        </div>
        <div className='privacy-text-container'>
          <p className="privacy-paragraph">Welcome to Rairer! These Terms of Use ("Terms") govern your use of our website, services, and applications (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree with any part of these Terms, you must not use our Service.</p>
          
          <h3 className='privacy-title'>1. Interpretation and Definitions</h3>
          <ul>
            <li className='privacy-paragraph'>"Company," "We," "Us," or "Our" refers to Rairer Dynamics Limited, Lagos, Nigeria.</li>
            <li className='privacy-paragraph'>"You" refers to the individual accessing or using the Service, or the company or other legal entity on whose behalf the individual is accessing the Service.</li>
            <li className='privacy-paragraph'>"Account" refers to a unique account created to access our Service.</li>
            <li className='privacy-paragraph'>"Content" refers to any text, images, videos, software, or other material provided by Us or other users on the Service.</li>
          </ul>
          
          <h3 className='privacy-title'>2. Acceptance of Terms</h3>
          <p className="privacy-paragraph">By using the Service, you confirm that you have read, understood, and agree to abide by these Terms. We may modify these Terms at any time, and continued use of the Service constitutes acceptance of the updated Terms.</p>

          <h3 className='privacy-title'>3. Use of the Service</h3>
          <p className="privacy-paragraph">You agree to:</p>
          <ul>
            <li className='privacy-paragraph'>Use the Service only for lawful purposes.</li>
            <li className='privacy-paragraph'>Not engage in any activity that disrupts or interferes with the Service.</li>
            <li className='privacy-paragraph'>Phone number</li>
            <li className='privacy-paragraph'>Not attempt to gain unauthorised access to any part of the Service.</li>
          </ul>
          <p className="privacy-paragraph">We reserve the right to suspend or terminate your access if you violate these Terms.</p>
          
          <h3 className='privacy-title'>4. User Accounts</h3>
          <p className="privacy-paragraph">To access certain features of the Service, you may be required to create an Account. You agree to:</p>
          <ul>
            <li className='privacy-paragraph'>Provide accurate and complete information.</li>
            <li className='privacy-paragraph'>Keep your Account credentials confidential.</li>
            <li className='privacy-paragraph'>Notify Us immediately of unauthorised access to your Account.</li>
          </ul>
          <p className='privacy-paragraph'>We are not liable for any loss resulting from unauthorised use of your Account.</p>

          <h3 className='privacy-title'>5. Intellectual Property</h3>
          <p className="privacy-paragraph">All Content on the Service is owned by or licensed to Us. You may not copy, reproduce, distribute, or create derivative works without Our written permission.</p>
          
          <h3 className="privacy-title">6. Privacy Policy</h3>
          <p className="privacy-paragraph">Your use of the Service is also governed by Our Privacy Policy, which describes how We collect, use, and disclose your data. By using the Service, you consent to Our Privacy Policy.
          </p>

          <h3 className='privacy-title'>7. Prohibited Activities</h3>
          <p className="privacy-paragraph">You agree not to:</p>
          <ul>
            <li className='privacy-paragraph'>Engage in fraudulent or deceptive practices.</li>
            <li className='privacy-paragraph'>Upload or distribute harmful software, such as viruses.</li>
            <li className='privacy-paragraph'>Harass, threaten, or violate the rights of others.</li>
            <li className='privacy-paragraph'>Use automated systems to scrape or collect data from the Service.</li>
          </ul>
          
          <h3 className="privacy-title">8. Third-Party Links</h3>
          <p className="privacy-paragraph">The Service may contain links to third-party websites. We are not responsible for the content, policies, or practices of any third-party sites.</p>
          
          <h3 className="privacy-title">9. Termination</h3>
          <p className="privacy-paragraph">We may suspend or terminate your access to the Service if you violate these Terms. Termination does not affect any obligations or liabilities that you incurred before termination.</p>
          
          <h3 className="privacy-title">10. Limitation of Liability</h3>
          <p className="privacy-paragraph">To the fullest extent permitted by law, We are not liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
          
          <h3 className="privacy-title">11. Indemnification</h3>
          <p className="privacy-paragraph">You agree to indemnify and hold Us harmless from any claims, damages, or expenses arising from your use of the Service or your violation of these Terms.</p>
          
          <h3 className="privacy-title">12. Governing Law</h3>
          <p className="privacy-paragraph">These Terms are governed by the laws of Nigeria. Any disputes arising from these Terms shall be resolved in the courts of Nigeria.</p>
          
          <h3 className="privacy-title">13. Changes to Terms</h3>
          <p className="privacy-paragraph">We may update these Terms from time to time. We will notify you of any significant changes, and your continued use of the Service constitutes acceptance of the revised Terms.</p>
          
          <h3 className="privacy-title">14. Contact Us</h3>
          <p className="privacy-paragraph">
            If you have any questions about these Terms, you can contact Us:
          </p>
          <p className="privacy-paragraph">
            By email: <a href="mailto:hello@rairer.com" style={{color: '#3EC182'}} rel="noopener noreferrer">hello@rairer.com</a>
          </p>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Terms;
